var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.58333 9.75V3.25C7.58333 2.96268 7.4692 2.68713 7.26603 2.48397C7.06287 2.2808 6.78732 2.16667 6.5 2.16667H2.16667C1.87935 2.16667 1.6038 2.2808 1.40063 2.48397C1.19747 2.68713 1.08333 2.96268 1.08333 3.25V9.20833C1.08333 9.35199 1.1404 9.48977 1.24198 9.59135C1.34357 9.69293 1.48134 9.75 1.625 9.75H2.70833",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.125 9.75H4.875",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.2917 9.75H11.375C11.5187 9.75 11.6564 9.69293 11.758 9.59135C11.8596 9.48977 11.9167 9.35199 11.9167 9.20833V7.23125C11.9164 7.10833 11.8744 6.98913 11.7975 6.89325L9.9125 4.537C9.86184 4.47356 9.79757 4.42232 9.72444 4.38707C9.65131 4.35181 9.57119 4.33345 9.49 4.33333H7.58333",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.20833 10.8333C9.80664 10.8333 10.2917 10.3483 10.2917 9.75C10.2917 9.15169 9.80664 8.66667 9.20833 8.66667C8.61002 8.66667 8.125 9.15169 8.125 9.75C8.125 10.3483 8.61002 10.8333 9.20833 10.8333Z",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.79167 10.8333C4.38998 10.8333 4.875 10.3483 4.875 9.75C4.875 9.15169 4.38998 8.66667 3.79167 8.66667C3.19336 8.66667 2.70833 9.15169 2.70833 9.75C2.70833 10.3483 3.19336 10.8333 3.79167 10.8333Z",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrier);
export default __webpack_public_path__ + "static/media/carrier.586d6441b650a92e85e00a592f0fd4f9.svg";
export { ForwardRef as ReactComponent };